import { storeProxyFactory } from '../storeProxyFactory.mts';

import { templatesState } from './templates.state.mts';
import { getEngagementTemplates } from './getEngagementTemplates.op.mts';


export const templatesStore = storeProxyFactory('Templates', templatesState, {
  default: getEngagementTemplates,
});
